import React from "react";
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  CardSubtitle,
} from "reactstrap";

export default function ModalUserRegister({
  modalUserRegister,
  setModalUserRegister,
  closeModalUserRegister,
  schedulesList,
  trySaveUser,
  eventId,
}) {
  const getLoginText = React.useCallback(() => {
    let _login = modalUserRegister.user.Login.replace(/ /g, ""); //Replace all
    if (!_login.includes(eventId)) {
      _login = `${eventId}${_login}`;
    }
    return _login;
  });

  return (
    <div style={{ paddingBottom: '10px' }}>
      <Row style={{ marginBottom: 10 }}>
        <CardSubtitle>
          {modalUserRegister.user.ID ? 'Editar' : 'Novo'} Usuário
        </CardSubtitle>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Login *`}
          </Label>
          <Input
            className="form-control"
            type="text"
            value={modalUserRegister.user.Login}
            onChange={(e) => setModalUserRegister({ ...modalUserRegister, user: { ...modalUserRegister.user, Login: e.target.value } })}
            onBlur={() => setModalUserRegister({ ...modalUserRegister, user: { ...modalUserRegister.user, Login: getLoginText() } })}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Nome *`}
          </Label>
          <Input
            className="form-control"
            type="text"
            value={modalUserRegister.user.Nome}
            onChange={(e) => setModalUserRegister({ ...modalUserRegister, user: { ...modalUserRegister.user, Nome: e.target.value } })}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Email *`}
          </Label>
          <Input
            className="form-control"
            type="text"
            value={modalUserRegister.user.Email}
            onChange={(e) => setModalUserRegister({ ...modalUserRegister, user: { ...modalUserRegister.user, Email: e.target.value } })}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Perfil *`}
          </Label>
          <Input
            className="form-control"
            type="select"
            value={modalUserRegister.user.Perfil}
            onChange={(e) => setModalUserRegister({ ...modalUserRegister, user: { ...modalUserRegister.user, Perfil: e.target.value } })}
          >
            <option value="">Selecione</option>
            <option value="admin">Administrador</option>
            <option value="staff">Staff</option>
            <option value="controller">Controlador</option>
          </Input>
        </Col>
      </Row>
      {modalUserRegister.user.Perfil === 'staff' && (
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Programação *`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={modalUserRegister.user.PerfilProgramacao}
              onChange={(e) => setModalUserRegister({ ...modalUserRegister, user: { ...modalUserRegister.user, PerfilProgramacao: e.target.value } })}
            >
              <option value="">Selecione</option>
              {schedulesList.map(s => (
                <option value={s.value}>{s.text}</option>
              ))}
            </Input>
          </Col>
        </Row>
      )}
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Senha *`}
          </Label>
          <Input
            className="form-control"
            type="text"
            value={modalUserRegister.user.Senha}
            onChange={(e) => setModalUserRegister({ ...modalUserRegister, user: { ...modalUserRegister.user, Senha: e.target.value } })}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%' }}>
            <div style={{ padding: 3 }}>
              <Button
                color="danger"
                onClick={() => closeModalUserRegister()}
              >
                Cancelar
              </Button>
            </div>
            <div style={{ padding: 3 }}>
              <Button
                color="success"
                onClick={() => trySaveUser()}
              >
                Salvar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
